import * as ld from "launchdarkly-js-client-sdk";
import { datadogRum } from "@datadog/browser-rum";

/**
 * Wrapper function for testabilty as LD's initialize is read-only
 * @param envKey launch darkly environment key
 * @param context user context
 * @returns LDClient
 */

export class ldWrapper {
  static initializeLaunchDarkly(
    envKey: string,
    context: ld.LDContext,
  ): ld.LDClient {
    return ld.initialize(envKey, context, {
      inspectors: [
        {
          type: "flag-used",
          name: "dd-inspector",
          method: (key: string, detail: ld.LDEvaluationDetail) => {
            datadogRum.addFeatureFlagEvaluation(key, detail.value);
          },
        },
      ],
    });
  }
}
